import {Actions, State} from './CheckInModal.types';

export const initialState = {
  answers: {},
  shuffle: false,
  shuffleDirection: 'right',
  step: 0,
} as State;

/**
 * This is a reducer function that returns the appropriate state values for the
 * CheckInModal component. It includes state values for the users cumulative
 * CheckIn answers, as well as UI state for the stack of cards.
 */
export function reducer(state: State, action: Actions): State {
  switch (action.type) {
    case 'SubmitAnswer': {
      return {
        ...state,
        shuffle: true,
        shuffleDirection: action.payload.answerBoolean ? 'right' : 'left',
        answers: {
          ...state.answers,
          [action.payload.id]: action.payload.answerBoolean,
        },
      };
    }
    case 'StopShuffle': {
      return {...state, step: state.step + 1, shuffle: false};
    }
    case 'StartShuffle': {
      return {...state, shuffle: true};
    }
    case 'SetStep': {
      return {...state, step: action.payload};
    }
    default: {
      return state;
    }
  }
}

/**
 * Returns the state values for a user's CheckIn answers in the
 * correct input format for the CreateCheckInAnswers gql mutation.
 */
export function getAnswerSubmissionInput(answers: State['answers'] = {}) {
  return Object.keys(answers).map(questionId => ({answerBoolean: answers[questionId], questionId}));
}
